<script setup>
import ModalWrapper from '@/modals/ModalWrapper';
import { ref, computed, onMounted } from 'vue';
import { useToast } from 'vue-toastification';
import { useKaleadicalStore } from '@/stores/kaleadical';
import { storeToRefs } from 'pinia';
import * as kaleadicalHelper from '@/utils/kaleadicalHelper';

const { active } = storeToRefs(useKaleadicalStore());

const kaleadicalsHabits = computed(() => {
    return active.value.habits.map((habit, index) => {
        return {
            ...habit,
            size: 100 + index * 5,
        };
    });
});

const props = defineProps({
    kaleadical: {
        type: Object,
        default: () => ({
            thumbnail: '',
            name: '',
            description: '',
            habits: [],
        })
    },
    mode: {
        type: String,
        default: 'Create'
    }
});

const emit = defineEmits(['close-modal']);
const form = ref({ ...props.kaleadical });

const habits = ref(form.value.habits);
const toast = useToast();

const habitContainer1 = ref(null);

// import { useOptionsStore } from '@/stores/options';
// const optionsStore = useOptionsStore();

const kaleadicalStore = useKaleadicalStore();
const { updateKaleadical } = kaleadicalStore;

const save = async () => {
    try {
        const action =  updateKaleadical;
        const toastMessage = 'Habit tracked successfully';

        await action({
            ...form.value,
        });

        toast.success(toastMessage);
        emit('close-modal');
    } catch (error) {
        toast.error('An unexpected error occurred');
    }
};

const updateHabitCount = async (habit, isIncrement) => {
    // Increment or decrement the count based on the action
    if (isIncrement) {
        habit.count++;
    } else {
        if (habit.count > 0) {  // Ensure count doesn't go below 0
            habit.count--;
        }
    }

    // Update habit with the new count
    const action = updateKaleadical;
    await action({
        ...form.value,
        count: habit.count,  // Ensure count is updated in the form data
    });

    // Re-render habits if needed
    if (kaleadicalsHabits.value.length > 0 && habitContainer1.value) {
        kaleadicalHelper.renderHabits(kaleadicalsHabits.value, habitContainer1.value);
    }
};

onMounted(() => {
    if (kaleadicalsHabits.value.length > 0 && habitContainer1.value) {
        kaleadicalHelper.renderHabits(kaleadicalsHabits.value, habitContainer1.value);
    }
});

</script>
<template>
<ModalWrapper fullscreen>
    <template #header>{{ $t('label.track') }}</template>

    <div class="flex justify-center flex-col items-center pb-2">
        <svg
            ref="habitContainer1"
            width="250"
            height="250"
            viewBox="0 0 600 600"
            xmlns="http://www.w3.org/2000/svg" />

        <h2>{{ kaleadical.name }}</h2>

    </div>
    
    <v-list class="w-full" lines="two">
        <v-list-item
            v-for="(habit,index) in habits"
            :key="index"
            class="border hover:bg-slate-100"
            :title="habit.name">
            <template #append="{ }">
                <div class="flex gap-2">
                    <v-btn
                        rounded="20"
                        text="-"
                        size="small"
                        @click="updateHabitCount(habit, false)"  />
                    <StyledInput
                        v-model="habit.count"
                        :clearable="false"
                        type="text"
                        class="w-[50px]"
                        readonly
                        :rules="[]" />
                    <v-btn
                        rounded="20"
                        text="+"
                        size="small"
                        @click="updateHabitCount(habit, true)" />
                </div>
            </template>
        </v-list-item>
    </v-list>

    <template #footer>
        <StyledSaveButton modal @save="save" />
    </template>
</ModalWrapper>
</template>
